import React, { useEffect, useState } from 'react';
import { IPayroll } from 'src/types/payroll';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import { IProvider } from 'src/types/provider';
import styles from '../assets/payroll-info.module.scss';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import ModalComponent from 'src/components/modals/ModalComponent';
import Loader from 'src/components/Loader';
import classNames from 'classnames';
import GeneralEnumService from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { getDataCsv } from '../helpers/getDataCsv';
import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { numberWithCommas } from '../../../../../../../../../helpers/format';

export interface StateProps {
    data: Partial<IPayroll> | null;
    dataEntities: {
        type?: string;
        list?: any;
    };
    inProgress: boolean;
    inProgressEntity: boolean;
}
export interface DispatchProps {
    getData: (id: string) => void;
    updatePayroll: ({ status, id, setPopup }: any) => void;
    getPayrollsEntities: (params: { id: string | number; caseEnt: string }) => void;
}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    payrollId: string;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}
const PayrollDetail: React.FunctionComponent<Props> = ({
    payrollId,
    getData,
    data,
    inProgressEntity,
    getPayrollsEntities,
    dataEntities,
    updatePayroll,
    inProgress,
}: Props) => {
    const entityModal: any = {
        CHANGE_STATUS: {
            action: () => updatePayroll({ status: +3, id: data?.id, setPopup }),
            body: <div>Are you sure you want to pay Payroll?</div>,
        },
    };
    const [popup, setPopup] = useState<boolean>(false);
    const [dataEnt, setdataEnt] = useState<any>([]);
    useEffect(() => {
        if (payrollId) {
            getData(`${payrollId}`);
            getPayrollsEntities({ id: `${payrollId}`, caseEnt: 'payroll_advances' });
        }

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        const dataEnt: any = [...dataEntities.list];

        let totalAll = 0;
        let totalPayableAll = 0;
        let coveredTotal = 0;
        let advancTotal = 0;

        if (dataEnt.length) {
            dataEnt.forEach((itPayl: any) => {
                totalAll += +itPayl.total;
                itPayl.total = `$${numberWithCommas(itPayl.total)}`;

                coveredTotal += +itPayl.coveredByInvoicePaymentAmount;
                itPayl.coveredByInvoicePaymentAmount = `$${numberWithCommas(itPayl.coveredByInvoicePaymentAmount)}`;

                advancTotal += +itPayl.advancePaid;
                itPayl.advancePaid = `$${numberWithCommas(itPayl.advancePaid)}`;

                totalPayableAll += +itPayl.totalPayable;
                itPayl.totalPayable = `$${numberWithCommas(itPayl.totalPayable)}`;
            });
            dataEnt.push({
                total: `$${numberWithCommas(totalAll)}`,
                totalPayable: `$${numberWithCommas(totalPayableAll)}`,
                advancePaid: `$${numberWithCommas(advancTotal)}`,
                coveredByInvoicePaymentAmount: `$${numberWithCommas(coveredTotal)}`,
            });
        }
        setdataEnt(dataEnt);

        // eslint-disable-next-line
    }, [dataEntities.list]);

    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('PayrollStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
    const statusObj: any = statusItems.find((itp) => itp.value === data?.status);
    const statusVal = statusObj ? statusObj.label : '';

    return (
        <div style={{ padding: '30px 0' }}>
            {inProgress || inProgressEntity || !data ? (
                <Loader />
            ) : (
                <div>
                    <div className={classNames(styles.topPanel, 'topPanel')}>
                        <div className={classNames(styles.boardInfo, 'badge-light mr-4')}>
                            <div>Paid for the Period:</div>
                            <div>
                                <span>
                                    {data.periodStart ? changeToZeroMoment(data.periodStart, 'MMM D, YYYY') : ''}
                                </span>
                                <span>
                                    {data.periodEnd ? ` - ${changeToZeroMoment(data.periodEnd, 'MMM D, YYYY')}` : ''}
                                </span>
                            </div>
                        </div>

                        <div className={classNames(styles.boardInfo, 'badge-light mr-4')}>
                            <div>
                                Status: <span>{statusVal}</span>
                            </div>
                            <div>
                                {+statusObj?.value === +3 ? (
                                    <span>
                                        {data.paidDate
                                            ? `(Payment Date: ${changeToZeroMoment(data.paidDate, 'MMM D, YYYY')} )`
                                            : ''}
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        {data.note ? (
                            <div className={classNames(styles.boardInfo, 'badge-light mr-4')}>
                                <div>Note:</div>
                                <div>
                                    <span>{data.note}</span>
                                </div>
                            </div>
                        ) : null}
                        <div className={classNames(styles.boardInfo, 'badge-light mr-4')}>
                            <div>Total Payable :</div>
                            <div>
                                <span>${numberWithCommas(data.totalPaid)}</span>
                            </div>
                        </div>
                    </div>
                    <SimpleTable
                        data={dataEnt}
                        columns={[
                            { id: 'caseNumber', label: 'Case Number', cellStyle: 'normal' },
                            /*    { id: 'invoiceNumber', label: 'Invoice Number', cellStyle: 'big' },*/
                            { id: 'clientLink', label: 'Client', cellStyle: 'big' },

                            { id: 'serviceType', label: 'Service Type', cellStyle: 'normal' },
                            { id: 'serviceLocation', label: 'Service Location', cellStyle: 'normal' },
                            { id: 'orderType', label: 'Order Type', cellStyle: 'normal' },
                            { id: 'sessionDate', label: 'Session Date', cellStyle: 'nowrap' },
                            { id: 'startTime', label: 'Start Time', cellStyle: 'nowrap' },
                            { id: 'endTime', label: 'End Time', cellStyle: 'nowrap' },
                            { id: 'totalUnits', label: 'Total Units', cellStyle: 'normal' },
                            { id: 'minPerUnit', label: 'Min per Unit', cellStyle: 'normal' },
                            { id: 'totalHours', label: 'Total Hours', cellStyle: 'normal' },
                            { id: 'type', label: 'Type', cellStyle: 'normal' },
                            { id: 'externalRatePerHour', label: 'External Rate per Hour', cellStyle: 'normal' },
                            { id: 'internalRatePerHour', label: 'Internal Rate per Hour', cellStyle: 'normal' },
                            { id: 'total', label: 'Total', cellStyle: 'normal' },
                            {
                                id: 'coveredByInvoicePaymentPer',
                                label: 'Covered by invoice payment, %',
                                cellStyle: 'normal',
                            },
                            {
                                id: 'coveredByInvoicePaymentAmount',
                                label: 'Covered by invoice payment, $',
                                cellStyle: 'normal',
                            },
                            { id: 'leftToPay', label: 'Left to Pay (underpaid invoice)', cellStyle: 'normal' },
                            { id: 'advancePaid', label: 'Advance Paid', cellStyle: 'normal' },
                            { id: 'totalPayable', label: 'Total Payable', cellStyle: 'normal' },
                        ]}
                    />
                    <ModalComponent
                        modal={popup}
                        setModal={setPopup}
                        dataBody={entityModal['CHANGE_STATUS']?.body}
                        action={entityModal['CHANGE_STATUS']?.action}
                    />
                    <div className={'d-flex justify-content-between'}>
                        <button
                            className={'btn btn-outline-info'}
                            onClick={() => {
                                getDataCsv(dataEnt);
                            }}
                        >
                            Export .csv
                        </button>
                        {user.getRoles().includes(UserRole.ROLE_ADMIN) && data?.status !== 3 ? (
                            <button
                                className={'btn btn-primary'}
                                onClick={() => {
                                    setPopup(true);
                                }}
                            >
                                $ Paid
                            </button>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PayrollDetail;
